import { getAllVoting } from "./get-voting";
import { VotingConstants } from "../../constants/voting.constants";
import { message } from "antd";
import moment from "moment";
import createVoting from "./utils/createVoting";
import createQuestion from "./utils/createQuestion";
import saveVotingFile from "./utils/saveVotingFile";
import bindAddresses from "./utils/bindAddresses";

const saveVoting = (formValues) => async (dispatch, getState) => {
	const {
		title: Title,
		description: Text,
		period: [DateStart, DateStop],
		questions,
		file,
		addresses,
	} = formValues;
	try {
		dispatch({ type: VotingConstants.ITEM_LOADING });

		const {
			data: { id: votingId },
		} = await createVoting({
			TypeId: 1,
			Title,
			Text,
			DateStart: moment(DateStart?.format("YYYY-MM-DD[T]HH:mm:[00]")).utc().format(),
			DateStop:  moment(DateStop?.format("YYYY-MM-DD[T]HH:mm:[59]")).utc().format(),
		});

		if (questions) {
			for (let questionOrder in questions) {
				await createQuestion(
					questions[questionOrder],
					votingId,
					Number(questionOrder)
				);
			}
		}
		if (file) {
			await Promise.all(
				file.fileList.map((file) => {
					if (file.originFileObj) {
						return saveVotingFile(file.originFileObj, votingId);
					}
					if (file instanceof File) {
						return saveVotingFile(file, votingId);
					}
				})
			);
		}
		if (addresses) {
			const {
				votingStore: {
					addresses: { addresses: addressesTree },
				},
			} = getState();
			await bindAddresses(addresses, addressesTree, votingId);
		}
		dispatch({ type: VotingConstants.ITEM_LOADED });
		dispatch(getAllVoting());
		return votingId;
	} catch (e) {
		console.error(e);
		message.error("Не получилось сохранить опрос, попробуйте позже");
	}
};

export default saveVoting;
